<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Escritório" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <!-- Default box -->
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-4 col-sm-3 col-xl-2">
              <nav class="nav nav-pills flex-column nav-tabs h-100" id="vert-tabs-tab" role="tablist" aria-orientation="vertical">
                <a class="nav-link active" id="vert-tabs-informacoes-tab" data-toggle="pill" href="#vert-tabs-informacoes" role="tab" aria-controls="vert-tabs-informacoes" aria-selected="true"><b>Informações</b> <i v-if="flagAbas.informacoes" class="fas fa-exclamation-triangle"></i></a>
                <a class="nav-link" id="vert-tabs-endereco-tab" data-toggle="pill" href="#vert-tabs-endereco" role="tab" aria-controls="vert-tabs-endereco" aria-selected="false"><b>Endereço</b> <i v-if="flagAbas.endereco" class="fas fa-exclamation-triangle"></i></a>
                <a class="nav-link" id="vert-tabs-contato-tab" data-toggle="pill" href="#vert-tabs-contato" role="tab" aria-controls="vert-tabs-contato" aria-selected="false"><b>Contato</b> <i v-if="flagAbas.contato" class="fas fa-exclamation-triangle"></i></a>
              </nav>
            </div>
            <div class="col-8 col-sm-9 col-xl-10">
              <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
                <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
                <b-spinner class="ml-2" variant="danger"></b-spinner>
              </div>
              <b-alert v-model="flagsDeControle.avisoDeErroNoFormulario.exibir" variant="danger" fade dismissible>
                <span class="avisoDangerAlerta">{{flagsDeControle.avisoDeErroNoFormulario.mensagem}}</span>
              </b-alert>
              <div class="tab-content" id="vert-tabs-tabContent">
                <div class="tab-pane text-left fade active show" id="vert-tabs-informacoes" role="tabpanel" aria-labelledby="vert-tabs-informacoes-tab">
                  <Informacoes
                    :buscarInformacoesDoCnpj="buscarInformacoesDoCnpj"
                    :desabilitarCampos="desabilitarCampos"
                    :enderecoLogotipo="formulario.informacoes.endereco_logotipo"
                    >
                    <template #upload-logotipo>
                      <br>
                    </template>
                    <template #informacoes-campos-adicionais-admin>
                      <div class="row col-md-12" v-if="!flagsDeControle.carregandoDados.status">
                        <div class="form-group col-md-12 col-lg-12 col-xl-12">
                            <label for="codigo_empresa" class="required">Código Empresa</label>
                            <input type="text" v-model="formulario.informacoes.codigo_empresa" :disabled="desabilitarCampos" class="form-control" id="codigo_empresa">
                            <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.codigo_empresa}}</div>
                        </div>
                      </div>
                    </template>
                    <template #informacoes-adicionais>
                      <div class="row col-md-12">
                        <div class="form-group col-md-12">
                          <label for="observacoes">Observações</label>
                          <textarea class="form-control" rows="7" v-model="formulario.informacoes.observacoes" :disabled="desabilitarCampos" id="observacoes" ></textarea>
                          <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.observacoes}}</div>
                        </div>
                        <div class="form-group col-md-12 col-lg-4 col-xl-3">
                          <label for="status_empresa">Status</label>
                          <select v-model="formulario.informacoes.status" class="form-control" id="status_empresa" :disabled="desabilitarCampos">
                            <option :value="1">Ativo</option>
                            <option :value="0">Inativo</option>
                            <option :value="2">Inadimplente</option>
                            <option :value="3">Suspenso</option>
                          </select>
                          <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.status}}</div>
                        </div>
                      </div>
                    </template>
                  </Informacoes>
                </div>
                <div class="tab-pane fade" id="vert-tabs-endereco" role="tabpanel" aria-labelledby="vert-tabs-endereco-tab">
                  <AbaEndereco v-model="formulario.endereco"/>
                </div>
                <div class="tab-pane fade" id="vert-tabs-contato" role="tabpanel" aria-labelledby="vert-tabs-contato-tab">
                  <Contato :desabilitarCampos="desabilitarCampos"/>
                </div>
                <!-- <div class="tab-pane fade" id="vert-tabs-consumo" role="tabpanel" aria-labelledby="vert-tabs-consumo-tab" v-if="!ehEmpresaOffice">
                  <MonitoramentoConsumo :listaConsumos="listaConsumos" :fields="fields" :flagsDeControle="flagsDeControle"/>
                </div> -->
                <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
                  <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                  <b-spinner class="ml-2" variant="danger"></b-spinner>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- ./ card-body ends-->
        <div class="card-footer text-right">
          <div class="row btn-group btn-group-justified" role="group">
            <div class="mr-1"><b-button class="botoes" variant="outline-success btn-sm mt-2" :disabled="desabilitarCampos" @click="salvarRegistro()">Salvar</b-button></div>
            <router-link class="" to="/escritorios">
              <b-button class="botoes" variant="outline-primary btn-sm mt-2" :disabled="desabilitarCampos">Voltar</b-button>
            </router-link>
          </div>
        </div>
      </div> <!-- ./ card ends-->
    </section> <!-- /.content -->
  </div> <!-- /.content-wrapper -->
</div> <!-- ./wrapper -->
</template>

<script>
import Cadastro from './js/cadastro-escritorio'
export default Cadastro
</script>

<style scoped>
@import "./scss/escritorio.scss";
</style>
